module.exports = __webpack_public_path__ + "static/media/Icon ionic-ios-videocam.99087b75.svg";